<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Traslado entre Caja y Bancos
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i> Caja → Banco
			</label>

			<input type="radio" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL" name="pcss3t"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-piggy-bank"></i> Banco → Caja
			</label>

            <input type="radio" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL" name="pcss3t"
				[(ngModel)]="history" [value]="2" id="tab3" class="tab-content-3">
			<label for="tab3" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-cash-register"></i> Caja → Caja
			</label>

            <input type="radio" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL" name="pcss3t"
				[(ngModel)]="history" [value]="3" id="tab4" class="tab-content-4">
			<label for="tab4" [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-building-columns"></i>Banco → Banco
			</label>

		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-cash-bank *ngIf="history==0"></app-cash-bank>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-transfer-bank-cash *ngIf="history==1"></app-transfer-bank-cash>
			</div>
		</div>
		<div class="row" [hidden]="history!=2">
			<div class="col" id="list-container">
				<app-transfer-cash-cash *ngIf="history==2"></app-transfer-cash-cash>
			</div>
		</div>
		<div class="row" [hidden]="history!=3">
			<div class="col" id="list-container">
				<app-transfer-bank-bank *ngIf="history==3"></app-transfer-bank-bank>
			</div>
		</div>

	</div>

</div>